exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:768px){._3a_Tm{float:left;margin-bottom:1rem;margin-right:1rem}}._22du1{color:#888;font-size:14.24px;font-size:.89rem}", ""]);

// exports
exports.locals = {
	"newsBody__image": "_3a_Tm",
	"news__footer": "_22du1"
};